export default "dist/images/9f96a5084f4e5f1a6c0041b41b34d62d.png";